export default "__VITE_ASSET__mImi2Xlx__"